import { Directive, ElementRef, HostListener, Input, OnChanges, AfterContentInit  } from '@angular/core';

@Directive({
  selector: '[appEmptyfieldfiller]'
})
export class EmptyfieldfillerDirective implements OnChanges, AfterContentInit {
  @Input() public number: any;
  @Input() public input: any;

  constructor( public el: ElementRef) {
    console.log(this.el.nativeElement.innerHTML)
    if (this.el.nativeElement.innerHTML === '') {
      console.log('Empty  Field');
      this.el.nativeElement.innerHTML = '--';
    }
  }
  ngAfterContentInit() {
    console.log(this.el.nativeElement.innerHTML)
}

  @HostListener('change') ngOnChanges() {
    console.log('test');
}

}
